var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column pa-4"},[_c('m-image-picker',{attrs:{"label":_vm.$t('profile.personal.image'),"user":_vm.me},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }